import React from 'react';
import MessageMarkdown from '../../../Base/Utils/MessageMarkdown/MessageMarkdown';
import TextMessage from '../TextMessage';
import classNames from 'classnames';
import styles from './ListMessage.module.scss';
const ListMessage = ({ text, status, invertColor, customColor, list }) => {
    const renderList = () => {
        return list.sections.map(({ rows, title }, i) => {
            const shouldRenderTitle = list.sections.length > 1;
            return (React.createElement(React.Fragment, { key: i },
                shouldRenderTitle && React.createElement("span", null, title),
                React.createElement("ul", { className: styles.list }, rows.map(({ title, payload }) => (React.createElement("li", { key: payload },
                    React.createElement(MessageMarkdown, { text: title })))))));
        });
    };
    return (React.createElement("div", { dir: "auto", className: classNames(styles.listContainer, {
            [styles.whiteText]: invertColor,
        }), style: { color: customColor } },
        text && React.createElement(TextMessage, { text: text, status: status, invertColor: invertColor, customColor: customColor }),
        renderList()));
};
export default ListMessage;
